import type { ReactNode } from 'react';
import cn from '@/utils/merge-class-names';

interface Props {
  label: ReactNode;
  icon?: ReactNode;
  hidden?: boolean;
  className?: string;
  joined?: boolean;
  onClick?: () => void;
}

export function FlyoutMenuItem({ label, icon, className, hidden, onClick, joined }: Props) {
  return (
    <button
      type='button'
      className={cn(
        'h-14 select-none rounded-system-button bg-[#e0e0e0] text-center text-[#007AFF]',
        className,
        { hidden },
        joined &&
          'border-t-[#3C3C435C] [&:not(:first-child)]:rounded-t-none [&:not(:first-child)]:border-t-[0.33px] [&:not(:last-child)]:rounded-b-none',
      )}
      onClick={onClick}>
      {icon}

      {label}
    </button>
  );
}
